export default __webpack_public_path__ + "static/media/enhancedWebsiteSample2.7fc1f0b2.png";